import { useAuth } from "contexts/AuthContext";
import { UserRole } from "types/auth";

export const useRoleCheck = () => {
  const { user } = useAuth();

  const hasRole = (role: UserRole): boolean => {
    return user?.roles?.includes(role) ?? false;
  };

  const hasAnyRole = (roles: UserRole[]): boolean => {
    return user?.roles?.some((role) => roles.includes(role)) ?? false;
  };

  const hasAllRoles = (roles: UserRole[]): boolean => {
    return user?.roles?.every((role) => roles.includes(role)) ?? false;
  };

  const isAdmin = (): boolean => {
    return hasRole("admin");
  };

  return {
    hasRole,
    hasAnyRole,
    hasAllRoles,
    isAdmin,
  };
};
